//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gsap } from 'gsap';

export default {
    data() {
        return {
            details: [
                this.$t('technical_features.content.1'),
                this.$t('technical_features.content.2'),
                this.$t('technical_features.content.3'),
            ],
            reviews: [
                {
                    title: this.$t('reviewsContent.1.title'),
                    text: this.$t('reviewsContent.1.text'),
                    rating: 5,
                },
                {
                    title: this.$t('reviewsContent.2.title'),
                    text: this.$t('reviewsContent.2.text'),
                    rating: 5,
                },
                {
                    title: this.$t('reviewsContent.3.title'),
                    text: this.$t('reviewsContent.3.text'),
                    rating: 5,
                },
                {
                    title: this.$t('reviewsContent.4.title'),
                    text: this.$t('reviewsContent.4.text'),
                    rating: 5,
                },
            ],
        };
    },
    head() {
        return {
            meta: [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.$t('title'),
                },
            ],
            title: this.$t('title'),
        };
    },
    methods: {
        handleVideoVisibility(isVisible, entry) {
            if (!isVisible) return;

            gsap.to(entry.target, 0.8, {
                scaleX: 1,
                scaleY: 1,
            });

            this.$refs.video.play();
            this.$refs.videoMobile.play();
        },
    },
};
